module.exports = __webpack_public_path__ + "static/rappeur-72df9ddbd83d59545e1db21029e07525.png";